export const iconFontAwesomeTextformattingListCheck = (
	<i className="fa-solid fa-list-check"></i>
);
